import React, {useRef, useEffect} from "react";

import {BackHandler}  from 'react-native'

import {useNavigation} from '@react-navigation/native'

import * as util from '../util/util'

import { ViewDegradeVertical} from '../componentes/ViewDegradeVertical';

import FormularioSelecionarItem, {TIPO_ANUNCIO_ITEM} from '../componentes/FormularioSelecionarItem'

import { TELA_ANUNCIO } from "../util/constantes";



export default function TelaAnuncio(){

	const navegacao = new useNavigation();

	const formularioSelecionarItem  = useRef(null)


	const voltar = () => {
		navegacao.replace(util.processaVoltar())
		return true;
	};
	

	useEffect(() => {
		
		util.print("TelaAnuncio")

		BackHandler.addEventListener('hardwareBackPress', voltar);

		return () => {
		  BackHandler.removeEventListener('hardwareBackPress', voltar);
		};	

	}, []); 


	return (

		<ViewDegradeVertical titulo="Minha Loja" voltar={()=>voltar()}>  
			<FormularioSelecionarItem ref={formularioSelecionarItem} 
										tipo={TIPO_ANUNCIO_ITEM} voltarPara={TELA_ANUNCIO}/>
		</ViewDegradeVertical>
	);
}